import sdl from '@jds/react-generated-sdl/JDSDatepickerCalendarRow';
import type { JDSDatepickerCalendarRowProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerCalendarRowProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSDatepickerCalendarRow',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerCalendarRow = withLogic(
  Component
) as React.FC<JDSDatepickerCalendarRowProps> & { slotName?: string };

DatepickerCalendarRow.displayName = 'DatepickerCalendarRow';
DatepickerCalendarRow.slotName = 'jds_datepicker_calendar_row';

export { DatepickerCalendarRow, type JDSDatepickerCalendarRowProps };
